import {ValidationProvider, ValidationObserver, extend, localize} from "vee-validate"
import ja from "vee-validate/dist/locale/ja.json"
import * as rules from "vee-validate/dist/rules"

export default Vue => {
  for (let rule in rules) {
    extend(rule, rules[rule])
  }
  localize("ja", ja)

  Vue.component("ValidationProvider", ValidationProvider)
  Vue.component("ValidationObserver", ValidationObserver)
}
